import Vue from "vue";
import VueI18n from "vue-i18n";

import customEN from "@/locales/lang/en"; // 自定义语言包
import customCN from "@/locales/lang/zh-cn"; // 自定义语言包
import customTW from "@/locales/lang/zh-tw"; // 自定义语言包
import customJA from '@/locales/lang/ja';
import customHi from '@/locales/lang/hi';
import customKO from '@/locales/lang/ko';
import enLocale from "element-ui/lib/locale/lang/en"; // 英文
import cnLocale from "element-ui/lib/locale/lang/zh-CN"; // 中文简体
import twLocale from "element-ui/lib/locale/lang/zh-TW"; // 中文繁体
import jaLocale from "element-ui/lib/locale/lang/ja"; // japan
import koLocale from "element-ui/lib/locale/lang/ko";

import { localeMap } from "@/components/company-common-components/constants";

Vue.use(VueI18n);

const DEFAULT_LOCALE = "en";

// localStorage "language" is the JSON-serialised language object, not a locale
// tag — resolve `code` through localeMap like the switchers do.
function getStoredLocale() {
  try {
    const stored = localStorage.getItem("language");
    if (!stored) return DEFAULT_LOCALE;
    return localeMap.get(JSON.parse(stored)?.code) || DEFAULT_LOCALE;
  } catch (error) {
    return DEFAULT_LOCALE;
  }
}

// Element.i18n((key, value) => i18n.t(key, value));
export default new VueI18n({
  locale: getStoredLocale(), // 指的是当前的多语言的类型 随意定义的字符串,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: {
    "en": {
      ...enLocale,
      ...customEN,
    },
    "zh-cn": {
      ...cnLocale,
      ...customCN,
    },
    "zh-tw": {
      ...twLocale,
      ...customTW,
    },
    "ja": {
      ...jaLocale,
      ...customJA
    },
    "ko": {
      ...koLocale,
      ...customKO,
    },
    'hi': {
      ...customHi,
    }
  }, // 指的是当前的语言包
});
